import { getBuilderConfig } from "@/config/getCachedBuilderContext";

export const getBuilderConfigKey = (key: string) => {
    const builderConfig = getBuilderConfig();
    return builderConfig[key];
}